import { createAsyncThunk } from "@reduxjs/toolkit";
import { getData } from "../../common/redux/ApiClient";

export const getMarcas = createAsyncThunk("sample/getMarcas", async (_) => {
  return await getData("https://parallelum.com.br/fipe/api/v1/carros/marcas");
});
